<template>
  <div class="crm-page">
    <div class="crm-hero">
      <div>
        <div class="crm-eyebrow">客户管理CRM</div>
        <h2>黑名单 / 无效客户</h2>
        <p>
          区分黑名单客户、空号客户、错号客户、明确拒绝客户，支持查看原因、恢复和永久屏蔽入口预留。
        </p>
      </div>
      <div class="crm-actions">
        <el-button icon="el-icon-download" @click="notifyPending('导出')"
          >导出（待开发）</el-button
        >
      </div>
    </div>

    <el-tabs v-model="activeTab">
      <el-tab-pane label="黑名单客户" name="blacklist"></el-tab-pane>
      <el-tab-pane label="空号客户" name="empty"></el-tab-pane>
      <el-tab-pane label="错号客户" name="wrong"></el-tab-pane>
      <el-tab-pane label="明确拒绝客户" name="reject"></el-tab-pane>
    </el-tabs>

    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>{{ activeLabel }}</span>
        <el-tag size="mini" type="info">可恢复 / 永久屏蔽待开发</el-tag>
      </div>
      <el-table :data="filteredCustomers" stripe border>
        <el-table-column
          prop="name"
          label="客户姓名"
          min-width="120"
        ></el-table-column>
        <el-table-column label="手机号" min-width="160">
          <template slot-scope="scope">
            <crm-phone-field :phone="scope.row.phone" status="offline" />
          </template>
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="公司名称"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="blacklistReason"
          label="原因"
          min-width="140"
        ></el-table-column>
        <el-table-column
          prop="ownerName"
          label="原归属员工"
          min-width="120"
        ></el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="restoreCustomer(scope.row)"
              >恢复</el-button
            >
            <el-button type="text" @click="notifyPending('永久屏蔽')"
              >永久屏蔽</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { createOperationLog, loadCrmState, saveCrmState } from "./mock";
import CrmPhoneField from "./PhoneField.vue";

export default {
  name: "CrmInvalidCustomers",
  components: { CrmPhoneField },
  data() {
    return {
      activeTab: "blacklist",
      state: loadCrmState(this.$store.getters.GET_TITLE || "当前员工"),
    };
  },
  computed: {
    operatorName() {
      return this.$store.getters.GET_TITLE || "当前员工";
    },
    activeLabel() {
      const map = {
        blacklist: "黑名单客户",
        empty: "空号客户",
        wrong: "错号客户",
        reject: "明确拒绝客户",
      };
      return map[this.activeTab];
    },
    filteredCustomers() {
      return (this.state.customers || []).filter((item) => {
        if (this.activeTab === "blacklist") return !!item.blacklistReason;
        if (this.activeTab === "empty")
          return item.blacklistReason === "空号" || item.subStatus === "空号";
        if (this.activeTab === "wrong")
          return item.blacklistReason === "错号" || item.subStatus === "错号";
        if (this.activeTab === "reject")
          return (
            item.blacklistReason === "明确拒绝" || item.subStatus === "拒接"
          );
        return false;
      });
    },
  },
  methods: {
    notifyPending(label) {
      this.$message.warning(`${label}为预留功能，待二阶段接入。`);
    },
    restoreCustomer(row) {
      const target = (this.state.customers || []).find(
        (item) => item.id === row.id
      );
      if (!target) return;
      target.blacklistReason = "";
      target.mainStatus = "跟进中";
      target.subStatus = "已接通";
      this.state.operationLogs.unshift(
        createOperationLog(
          this.operatorName,
          "黑名单/无效客户",
          "恢复客户",
          target.name,
          "从无效名单恢复",
          "成功",
          ""
        )
      );
      saveCrmState(this.state);
      this.state = loadCrmState(this.operatorName);
      this.$message.success("客户已恢复回正常跟进池");
    },
  },
};
</script>

<style scoped>
.crm-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 24px 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.04);
}
.crm-eyebrow {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 12px;
  font-weight: 700;
}
.crm-hero h2 {
  margin: 12px 0 0;
  font-size: 28px;
  color: #111827;
}
.crm-hero p {
  margin: 10px 0 0;
  color: #6b7280;
  line-height: 1.7;
}
.crm-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 1200px) {
  .crm-hero {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
